import React from "react"
import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import Text from "@/components/common/Text"
import { getCssSizeValue } from "@/utils/utils"
import useCurrentBranchData from "@/hooks/useCurrentBranchData"
import Sections from "@/components/BranchNavigator/Sections"

const Wrapper = styled(GridContainer)`
	padding-top: ${getCssSizeValue(64)};
	grid-template-rows: auto 1fr;
`

const Name = styled(Text)`
	margin-left: ${getCssSizeValue(20)};
`

const Info = ({ data, className = "", ...props }) => {
	const branch = useCurrentBranchData()

	return (
		<Wrapper key={branch.id} className={`no-margin grid-12 ${className}`} {...props}>
			<Name className="col-desktop-12 typo-borna-07">{branch?.fullName || branch?.name}</Name>
			<Sections data={data} className="col-desktop-4" />
		</Wrapper>
	)
}

export default Info
